import React from 'react';
import { observer } from 'mobx-react';

import { RootStoreContext } from '../../../../../../context';

export default Component => {
  @observer
  class withStoreMessages extends React.Component {

    static contextType = RootStoreContext;
    
    render () {
      return (
        <Component
          seenTimestamp={this.context.seenTimestamp}
          loadMessages={this.context.privateMessagingStore.loadConversationSessionMessages}
          messages={this.context.privateMessagingStore.messages}
          {...this.props}
          inputAreaHeight={this.context.privateMessagingStore.inputAreaHeight}
        />
      );
    }
  }
  return withStoreMessages;
}